import React, { useState, useEffect } from "react";
import styles from "./AudienceFooter.module.scss";
import { Button, Input, notification, Select, Alert } from "antd";
import { apiRequest } from "../../../util/services";
import { Modal } from "components/General/ModalFormComponents";
import { useTranslation } from "react-i18next";

// Audiences are switched off: the API's audiences blueprint is not registered, so every
// audiences/* call 404s. Set to true together with re-enabling it in the API.
const AUDIENCES_ENABLED = false;

const AudienceFooter = ({
  resetReviewsPage,
  deleteModal,
  deletingReview,
  currentDashboardHash,
  setSelectedReviewIds,
  setDeleteModal,
  setResetReviewsPage,
  setDeletingReview,
  selectedReviewIDs,
  usersCheckList,
  setUsersCheckList,
  setTweetsCheckList,
  user,
}) => {
  const [newAudienceModalOpen, setNewAudienceModalOpen] = useState(false);
  const [addToAudienceModalOpen, setAddToAudienceModalOpen] = useState(false);
  const [audience, setAudience] = useState([]);
  const [target, setTarget] = useState("");
  const [currentAudience, setCurrentAudience] = useState("");
  const usersLength = Object.keys(usersCheckList).length;
  const opacity = usersLength === 0 ? 0 : 1;
  const { t } = useTranslation();

  const handleAddAudience = async () => {
    if (!currentAudience) {
      notification.error({
        message: t("notifications.33"),
      });
      return;
    }

    const result = await apiRequest("audiences/create", "POST", {
      user_id: user.uid,
      name: currentAudience,
    });
    if (result) {
      loadAudience(currentAudience);
    } else {
      notification.error({
        message: t("notifications.32"),
      });
    }
    setTweetsCheckList({});
    setUsersCheckList({});
    setNewAudienceModalOpen(false);
  };

  const loadAudience = async (currentAudience) => {
    const result = await apiRequest("audiences/all", "POST", {
      user_id: user.uid,
    });
    if (result) {
      setAudience(result);
      if (currentAudience) {
        let currTarget;
        result.forEach((aud) => {
          if (aud.Name === currentAudience) currTarget = aud.ID;
        });
        if (currTarget) {
          setTarget(currTarget);
          addCheckedToAudience(currTarget);
        }
      }
    }
    // else {
    //   notification.error({ message: "Action not allowed" });
    // }
  };

  const addCheckedToAudience = async (currTarget) => {
    let user_ids = [];
    let user_emails = [];
    let user_phones = [];
    Object.keys(usersCheckList).forEach((key) => {
      if (usersCheckList[key].gpid) user_ids.push(usersCheckList[key].gpid);
      if (usersCheckList[key].DocEmail)
        user_emails.push(usersCheckList[key].DocEmail);
      if (usersCheckList[key].DocPhone)
        user_phones.push(usersCheckList[key].DocPhone);
    });
    let audience_id = currTarget ? currTarget : target;
    const result = await apiRequest(
      "audiences/users/add",
      "POST",
      {
        firebase_id: user.uid,
        audience_id,
        user_ids,
        user_phones,
        user_emails,
      },
      true
    );
    if (!result?.error) {
      notification.success({
        message: t("topic_library.22"),
      });
    } else {
      notification.error({
        message: result?.error,
      });
    }
    setUsersCheckList({});
    setTweetsCheckList({});
    setAddToAudienceModalOpen(false);
  };

  const keyPressed = (event, callback) => {
    if (event.key === "Enter") {
      callback();
    }
  };
  //Deleting Reviews Logic
  const handleDeleteReview = async () => {
    //starts the loading state
    setDeletingReview(true);

    const payload = {
      dashboard_id: currentDashboardHash,
      review_ids: selectedReviewIDs,
    };

    const result = await apiRequest(
      "dashboards/delete_reviews",
      "POST",
      payload
    );

    if (result.success) {
      setResetReviewsPage(!resetReviewsPage);
      notification.success({
        message: t("notifications.151"),
      });
    } else {
      notification.error({
        message: result?.error || t("notifications.152"),
      });
    }
    //sets the selected reviews to null
    setSelectedReviewIds([]);
    //set loading state to false
    setDeletingReview(false);
    //closes the pop-up
    setDeleteModal(false);
    //selected Users be zero
    setTweetsCheckList({});
    setUsersCheckList({});
  };

  return (
    <div>
      {/* Hidden while nothing is selected; it must not catch clicks then either. */}
      <div
        className={styles.container}
        style={{ opacity, pointerEvents: usersLength === 0 ? "none" : undefined }}
        aria-hidden={usersLength === 0}
      >
        <h4>
          {usersLength <= 1
            ? `${t("others.61", { usersLength: usersLength })}`
            : `${t("others.60", { usersLength: usersLength })}`}
        </h4>
        <div className={styles.optionContainer}>
          {selectedReviewIDs.length ? (
            <div
              className={styles.deleteWrapper}
              onClick={() => {
                setDeleteModal(true);
              }}
            >
              <Button type="primary">
                <img src={"/assets/trash.svg"} alt="" width={24} />
              </Button>
            </div>
          ) : (
            <div></div>
          )}
          {AUDIENCES_ENABLED && (
            <Button
              onClick={() => {
                loadAudience();
                setAddToAudienceModalOpen(true);
              }}
              type="primary"
            >
              <i className="fa fa-plus"></i>
            </Button>
          )}
        </div>
      </div>
      <Modal
        title={t("engage.11")}
        showModal={newAudienceModalOpen}
        onSave={handleAddAudience}
        onClose={() => setNewAudienceModalOpen(false)}
        showSaveButton={true}
        showCancelButton={true}
        textonButton={t("button.15")}
        titleAsset=""
        widthofmodal="450px"
      >
        <Input
          placeholder={t("placeholder.10")}
          onKeyPress={(e) => keyPressed(e, handleAddAudience)}
          onChange={(e) => setCurrentAudience(e.target.value)}
        />
      </Modal>
      <Modal
        showModal={addToAudienceModalOpen}
        onClose={() => setAddToAudienceModalOpen(false)}
        onSave={() => addCheckedToAudience()}
        showSaveButton={true}
        textonButton={t("button.11")}
        titleAsset=""
        title="Add Users To Audience"
        widthofmodal="525px"
      >
        {
          <p
            style={{
              color: "white",
              fontSize: "15px",
              marginBottom: "20px",
              marginLeft: "20px",
            }}
          >
            {usersLength} users selected
          </p>
        }

        <div className={styles.audienceSelection}>
          <Select
            showSearch
            style={{
              width: "235px",
              marginBottom: "20px",
              marginRight: "20px",
              marginLeft: "20px",
              color: "black",
            }}
            optionFilterProp="children"
            onChange={setTarget}
            filterOption={(input, option) =>
              option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
            }
            placeholder={<div className={styles.on}>{t("placeholder.8")}</div>}
          >
            {audience.map((item) => {
              return <Select.Option value={item.ID}>{item.Name}</Select.Option>;
            })}
          </Select>
          <p className={styles.or}>OR</p>
          <div className={styles.con}>
            <Button
              type="primary"
              onClick={() => {
                setAddToAudienceModalOpen(false);
                setNewAudienceModalOpen(true);
              }}
            >
              {t("button.37")}
            </Button>
          </div>
        </div>
      </Modal>
      <Modal
        showModal={deleteModal}
        onClose={() => {
          setDeleteModal(false);
        }}
        onSave={() => {
          handleDeleteReview();
        }}
        showSaveButton={true}
        showCancelButton={true}
        hideCloseIcon={true}
        textonButton={t("button.2")}
        titleAsset=""
        title="Delete Reviews"
        loadingSaveClick={deletingReview ? true : false}
        widthofmodal="450px"
        disabled={deletingReview ? true : false}
        isDeleteModal={true}
      >
        <p>Are you sure you want to delete the reviews permanently ?</p>
      </Modal>
    </div>
  );
};

export default AudienceFooter;
